import React, { useState, useMemo } from 'react';
import sidebarBgImage from '../../assets/img/sidebar/istockphoto-1372399516-612x612.jpg';
import logoqa from '../../assets/img/sidebarimhs23.png';
import './Sidebar.css';
import { MdPageview, MdDashboard, MdExitToApp } from 'react-icons/md';
import { NavLink } from 'react-router-dom';
import { isMobile, isTablet } from 'react-device-detect';
import GetSessionData from '../../utils/GetSessionData';
import {
  Collapse,
  Nav,
  Navbar,
  NavItem,
  NavLink as BSNavLink,
} from 'reactstrap';
import bn from '../../utils/bemnames';
import { AiFillTags, AiFillSignal } from 'react-icons/ai';

const sidebarBackground = {
  backgroundImage: `url("${sidebarBgImage}")`,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
};

const bem = bn.create('sidebar');

const Sidebar = () => {
  const [state, setState] = useState({
    isOpenIndent: true,
    isOpenPurchase: true,
  });

  const {
    Indent_User,
    Indent_Approval_User,
    PO_User,
    PO_Approval_User,
  } = useMemo(() => GetSessionData(), []);

  // Always shown items
  const dashboardItem = [
    { to: '/Dashboard', name: 'Dashboard', exact: false, Icon: MdDashboard }
  ];

  const POdashboardItem = [
    { to: '/DashboardPO', name: 'Dashboard', exact: false, Icon: MdDashboard }
  ];

  // Items shown at the end
  const footerItems = [
    {
      to: '/outstanding',
      name: 'OutStanding',
      exact: false,
      Icon: MdPageview,
      show: Indent_User === 'N' && Indent_Approval_User === 'N'
    },
    { to: '/logout', name: 'Log out', exact: false, Icon: MdExitToApp, show: true }
  ];

  // Conditional items based on permissions
  const indentItems = [
    {
      to: '/ViewIndent',
      name: 'Indent',
      exact: false,
      Icon: AiFillTags,
      show: Indent_User === 'Y'
    },
    {
      to: '/IndentApproval',
      name: 'Indent Approval',
      exact: false,
      Icon: AiFillTags,
      show: Indent_Approval_User === 'Y'
    },
  ];

  const purchaseItems = [
    {
      to: '/viewpo',
      name: 'Purchase Order',
      exact: false,
      Icon: AiFillTags,
      show: PO_User === 'Y'
    },
    {
      to: '/PurchaseOrderApprovalView',
      name: 'PO Approval',
      exact: false,
      Icon: AiFillSignal,
      show: PO_Approval_User === 'Y'
    },
  ];

  const handleClick = (section) => () => {
    setState(prev => ({ ...prev, [`isOpen${section}`]: !prev[`isOpen${section}`] }));
  };

  const handleSidebarControlButton = () => {
    document.querySelector('.cr-sidebar')?.classList.toggle('cr-sidebar--open');
  };

  const renderNavItem = ({ to, name, exact, Icon }, index, mobile = false) => (
    <NavItem
      key={index}
      className={bem.e('nav-item')}
      onClick={mobile ? handleSidebarControlButton : undefined}
    >
      <BSNavLink
        className="text-uppercase"
        tag={NavLink}
        to={to}
        activeClassName="active"
        exact={exact}
      >
        <Icon className={bem.e('nav-item-icon')} />
        <span>{name}</span>
      </BSNavLink>
    </NavItem>
  );

  const renderSection = (items, sectionName, mobile) => {
    const visibleItems = items.filter(item => item.show);
    if (visibleItems.length === 0) return null;

    return (
      <>
        <NavItem className={bem.e('nav-item')} onClick={handleClick(sectionName)} />
        <Collapse isOpen={state[`isOpen${sectionName}`]}>
          {visibleItems.map((item, index) => renderNavItem(item, index, mobile))}
        </Collapse>
      </>
    );
  };

  const renderNav = (mobile = false) => (
    <Nav vertical>
      {/* Dashboard - Always first */}
      {Indent_User === 'N' && Indent_Approval_User === 'N' ?
        POdashboardItem.map((item, index) => renderNavItem(item, index, mobile))
        :
        dashboardItem.map((item, index) => renderNavItem(item, index, mobile))
      }

      {/* Indent section - Second if available */}
      {renderSection(indentItems, 'Indent', mobile)}

      {/* Purchase section - Third if available */}
      {renderSection(purchaseItems, 'Purchase', mobile)}

      {/* OutStanding and Log out - Always last */}
      {footerItems
        .filter(item => (item.show))
        .map((item, index) => renderNavItem(item, index, mobile))}

    </Nav>
  );

  return (
    <aside className={bem.b()} data-image={sidebarBgImage}>
      <div className={bem.e('background')} style={sidebarBackground} />
      <div className={bem.e('content')}>
        <Navbar>
          <div style={{ marginLeft: '-18px', marginTop: '-8px' }}>
            <img src={logoqa} width="228" height="88" alt="Logo" />
          </div>
        </Navbar>
        {isMobile || isTablet ? renderNav(true) : renderNav()}
      </div>
    </aside>
  );
};

export default Sidebar;